import { env } from 'config/env';

export const firebaseConfig = {
	apiKey: env.NEXT_PUBLIC_FIREBASE_API_KEY,
	authDomain: `${env.NEXT_PUBLIC_FIREBASE_PROJECT_ID}.firebaseapp.com`,
	storageBucket: `${env.NEXT_PUBLIC_FIREBASE_PROJECT_ID}.firebasestorage.app`,
	projectId: env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
	messagingSenderId: env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
	appId: env.NEXT_PUBLIC_FIREBASE_APP_ID,
	databaseURL: env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
};
